import NextImage from 'next/image'
import { ContentFulPageProps } from '../../types'
import styles from './styles.module.scss'

type ImageProps = {
  imageDesktopLarge: ContentFulPageProps['imageDesktopLarge']
  imageMobile: ContentFulPageProps['imageMobile']
  imageDesktop: ContentFulPageProps['imageDesktop']
  useGridLayout?: boolean
  classes?: string
}

export default function ContentImage({
  imageDesktopLarge,
  imageMobile,
  imageDesktop,
  useGridLayout = false,
  classes
}: ImageProps) {
  const ImageContent = (
    <picture className={styles.ImageCopySectionContainer__image}>
      {imageDesktopLarge?.file?.url && (
        <source
          media="(min-width: 1240px)"
          srcSet={imageDesktopLarge.file.url}
        />
      )}
      <source media="(min-width: 600px)" srcSet={imageDesktop.file.url} />
      <NextImage
        alt={imageMobile?.file.fileName}
        src={imageMobile?.file.url}
        width={
          imageMobile?.file.details.image?.width ||
          imageDesktop?.file.details.image?.width
        }
        height={
          imageMobile?.file.details.image?.height ||
          imageDesktop?.file.details.image?.height
        }
      />
    </picture>
  )

  return useGridLayout ? (
    <div
      className={`${styles.ImageCopySectionContainer__gallery} ${
        classes || ''
      }`}
    >
      {ImageContent}
    </div>
  ) : (
    ImageContent
  )
}
